<mat-list class="list-container">
  <ng-container *ngFor="let item of items">
    <ng-container
      *ngTemplateOutlet="listItem; context: { item: item, parentItem: null, isNested: false }"
    ></ng-container>
    <ng-container *ngIf="item.nestedItems?.length">
      <div class="nested-item-container" *ngFor="let nestedItem of item.nestedItems">
        <ng-container
          *ngTemplateOutlet="listItem; context: { item: nestedItem, parentItem: item, isNested: true }"
        ></ng-container>
      </div>
    </ng-container>
  </ng-container>
</mat-list>

<ng-template #listItem let-item="item" let-parentItem="parentItem" let-isNested="isNested">
  <mat-list-item *ngIf="item.quantity > 0" data-cy="item-row">
    <div class="item-container">
      <inventory-ui-item-label
        [item]="{
            itemId: item.itemId,
            name: item.name,
            editionName: item.type === 'app' ? item?.edition?.name : '',
            iconUrl: item.iconUrl,
            quantity: item.quantity,
            status: item.status,
          }"
        [showEditionName]="true"
        [showItemId]="false"
        [showStatus]="showStatus"
      />
      <span *ngIf="removeButtonEnabled" class="button-container">
        <button
          mat-icon-button
          type="button"
          data-cy="remove-button"
          (click)="removeItem(item.itemId, parentItem?.itemId, isNested)"
        >
          <mat-icon>clear</mat-icon>
        </button>
      </span>
    </div>
  </mat-list-item>
</ng-template>
